import { UPDATE_WIDGETS_WITH_ALARMS } from '../constants'

export default (widgetId, channel, alarms, remove = false) => ({
    type: UPDATE_WIDGETS_WITH_ALARMS,
    widgetId,
    channel,
    alarms,
    remove
})
